module.exports = __webpack_public_path__ + "static/img/xqhz_3.54b951f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xqhz/xqhz_3.png
// module id = 9Z1P
// module chunks = 171